import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { api } from "../lib/api";
import { Empty, Loading, PageHeader } from "../components/common";
import { Button } from "../components/ui/button";

export default function Notizie() {
  const [news, setNews] = useState(null);
  const [err, setErr] = useState(false);
  const load = (force) => {
    setNews(null);
    api(`/news${force ? "?force=true" : ""}`).then((d) => { setNews(d.news || []); setErr(false); if (d.news?.[0]) localStorage.setItem("news_last_seen", d.news[0].url || d.news[0].title); }).catch(() => { setNews([]); setErr(true); });
  };
  useEffect(() => { load(false); }, []);
  return (
    <div>
      <PageHeader subtitle="Dal Porto Turistico di Roma" title="News" actions={<Button variant="outline" className="rounded-full" onClick={() => load(true)} data-testid="news-refresh-button"><RefreshCw className="w-4 h-4 mr-1" />Aggiorna</Button>} />
      {!news ? <Loading /> : news.length === 0 ? <Empty title={err ? "Notizie non disponibili" : "Nessuna notizia"} text={err ? "Riprova più tardi." : "Non ci sono news pubblicate sul sito. Il Direttore può aggiungerle da Sito pubblico → News."} /> : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 stagger" data-testid="news-list">{news.map((n, i) => (
          <a key={i} href={n.url} target="_blank" rel="noreferrer" className="panel panel-hover !p-0 overflow-hidden flex flex-col" data-testid={`news-item-${i}`}>
            {n.image && <img src={n.image} alt={n.title} className="h-44 w-full object-cover" />}
            <div className="p-5 flex flex-col flex-1"><p className="text-xs text-slate-400 mb-2">{n.data}</p><p className="font-display font-bold text-[var(--navy)] leading-snug">{n.title}</p>
              {n.excerpt && <p className="text-sm text-slate-600 mt-2 line-clamp-3">{n.excerpt}</p>}<span className="mt-auto pt-4 text-sm font-semibold text-[var(--teal)]">Leggi tutto</span></div>
          </a>))}
        </div>)}
    </div>
  );
}
